import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from "zustand/middleware";
import { createJSONStorage } from 'zustand/middleware';

type dataUserDto = {
  id?: string | number;
  name?: string;
  lastName?: string;
  avatarUrl?: string;
  email?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
};

type userInterface = {
  dataUser: dataUserDto,
  updateDataUser: (newUserData: dataUserDto) => void;
  clearStore: () => void;
}

// Crear un almacenamiento personalizado
const storage = createJSONStorage(() => localStorage);

export const useUserStore = createWithEqualityFn<userInterface>()(
  persist(
    (set) => ({
      dataUser: {
        id: '',
        name: '',
        lastName: '',
        avatarUrl: '',
        email: '',
        isActive: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: null
      },

      updateDataUser: (newUserData: dataUserDto) => set({ dataUser: newUserData }),

      clearStore: () => {
        set({
          dataUser: {
            id: '',
            name: '',
            lastName: '',
            avatarUrl: '',
            email: '',
            isActive: false,
            createdAt: '',
            updatedAt: '',
            deletedAt: null
          },
        });
      },
    }),
    {
      name: "user-storage",
      storage
    }
  )
);
